import React, { Component } from 'react';
import { connect } from 'react-redux';

import FormulaireSelectionProjet from '../../../../composant/Capteur/Ajouter/FormulaireSelectionProjet/FormulaireSelectionProjet';
import FormulaireCourbe from './FormulaireCourbe/FormulaireCourbe';
import FormulaireSelectionDateHeureUnix from './FormulaireSelectionDateHeureUnix/FormulaireSelectionDateHeureUnix';
import FormulaireSelectUtsDate from './FormulaireSelectUtsDate/FormulaireSelectUtsDate';

import Bouton from '../../../UI/Bouton/Bouton';

import AttenteRequete from '../../../../hoc/AttenteRequete/AttenteRequete';
import Collapse from '../../../../hoc/Collapse/Collapse';

import * as requestType from '../../../../ressources/glossaires/glossaire_requetes';
import * as glossaire_type_de_graphe from '../../../../ressources/glossaires/glossaire_type_de_graphe';
import { jsDictionaryEquals } from '../../../../ressources/functionJS/jsDictionaryEquals';
import { checkMot } from '../../../../ressources/functionJS/checkMot';
import * as type_btn from '../../../../ressources/glossaires/glossaire_type_de_bouton';
import * as actions from '../../../../services/actions';
import help from '../../../../ressources/imgStatic/N_temp.gif';
import helpB from '../../../../ressources/imgStatic/n_line.gif';
import * as s from '../../../../ressources/StyleGlobal/StyleGlobal';
import { AiFillPlusCircle } from 'react-icons/ai';
import { AiOutlineCheck } from 'react-icons/ai';
import styles from './FormulaireGraphe.module.scss';
import FormulaireSelectionGabarits from '../../../UI/FormulaireSelectionGabarits/FormulaireSelectionGabarits';
import FormulaireSaisieDuree from '../../../UI/FormulaireSaisieDurée/FormulaireSaisieDuree';
import HoverButton from '../../../UI/BoutonHover/BoutonHover';
import FormulaireSelectionTimeZone from '../../../UI/FormulaireSelectionTimeZone/FormulaireSelectionTimeZone';
import AxisFormField from './FormFields/AxisFormField';
import Interrupteur from '../../../UI/Interrupteur/Interrupteur';
import MessageErreur, {
  classeChampEnErreur,
} from '../../../UI/MessageErreur/MessageErreur';
import {
  schemaNouveauGraphe,
  schemaModificationGraphe,
} from '../../../../services/schemas/graphe';
import {
  validerFormulaire,
  messageDuChamp,
} from '../../../../services/schemas/validerFormulaire';

const valeurParDefautCourbe = {
  //config générale d'une courbe
  name: '', //TYPE: String + ValeurParDéfaut: "" +  DESCRIPTION: nom de la courbe
  show_alarms: 1, //TYPE: int + ValeurParDéfaut: 1 +  DESCRIPTION: affichage des seuils sur le graphe, 1 (affiche les alarmes) ou 0 (masque les alarmes)
  formula: '', //TYPE: String + ValeurParDéfaut: "" +  DESCRIPTION: voir le document de syntaxe
  parameters: '', //TYPE: String + ValeurParDéfaut: "" +  DESCRIPTION: voir le document de syntaxe
  yaxis: 'y1', //TYPE: String + ValeurParDéfaut: "y1" +  DESCRIPTION: "y1" ou "y2"
  type: 'scatter', //TYPE: String + ValeurParDéfaut: "scatter" +  DESCRIPTION: "scatter" ou "bar"

  //configuration pour un type de courbe scatter
  mode: 'lines', //TYPE: String + ValeurParDéfaut: "lines+markers" +  DESCRIPTION: 'lines et/ou markers et/ou text' concaténer avec un "+"

  //configuration pour un mode incluant line
  line: {
    //TYPE: Object + ValeurParDéfaut: {} +  DESCRIPTION: si mode contient "line"
    dash: 'solid', //TYPE: String + ValeurParDéfaut: "solid" +  DESCRIPTION:  'solid' ou 'dashdot' ou 'dot'
    shape: 'linear', //TYPE: String + ValeurParDéfaut: "linear" +  DESCRIPTION: 'vh' ou 'hv' ou 'linear' ou 'spline' ou 'hvh' ou 'vhv'
  },
  color: '',
};

class FormulaireGraphe extends Component {
  state = {
    //paramètre par défaut du graphe
    private: 1,
    time_refresh: null,
    time_period: 2678400, // 31×24×60×60=2678400 secondes.  31 jour
    measures_num: null,
    cumul_interval: '', //'heure' ou 'jour' ou 'semaine' ou 'mois' ou 'annee'
    cumul_num: null,
    time_zone: 'Europe/Paris',
    select_time: [],
    time_interval: [null, null],

    graph_type_id: glossaire_type_de_graphe.graphe_x_t,
    graph_name: '',
    title: '',
    subtitle: '',
    showgrid: 1,
    showlegend: 1,
    xaxis: {
      title: '',
      type: 'date',
      range: [null, null],
    },
    yaxis: {
      title: '',
      type: 'linear',
      range: [null, null],
    },
    yaxis2: {
      title: '',
      type: 'linear',
      range: [null, null],
    },
    xaxis_type: 'date',
    yaxis_type: 'linear',
    yaxis2_type: 'linear',
    barmode: 'group',
    curves_conf_list: [],
    list_template_id: [],
    erreurs: {},
  };

  componentDidMount() {
    if (
      this.props !== undefined &&
      this.props.preconfigurerGraphe === undefined
    ) {
      this.setState({
        //todo: paramètre par défaut du graphe
        ...this.state,
      });
    } else if (
      this.props !== undefined &&
      this.props.preconfigurerGraphe !== undefined
    ) {
      this.setState({
        //todo: pré-configuration du formulaire
        ...this.state,
        ...this.props.preconfigurerGraphe,
        xaxis: {
          ...this.props.preconfigurerGraphe.xaxis,
        },
        yaxis: {
          ...this.props.preconfigurerGraphe.yaxis,
        },
        yaxis2: {
          ...this.props.preconfigurerGraphe.yaxis2,
        },
      });
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (
      this.state.curves_conf_list !== prevState.curves_conf_list ||
      this.state.graph_type_id !== prevState.graph_type_id
    ) {
      //liste formulaire de courbe
      let listeFormulaireCourbe = [];
      for (
        let indCourbe = 0;
        indCourbe < this.state.curves_conf_list.length;
        indCourbe++
      ) {
        listeFormulaireCourbe.push(
          <>
            <div className={[styles.info].join(' ')}>
              <FormulaireCourbe
                typoGraphe={this.state.graph_type_id}
                preConfigCourbe={{ ...this.state.curves_conf_list[indCourbe] }}
                gererConfigCourbe={(configCourbe) =>
                  this.gererCourbe(indCourbe, configCourbe)
                }
                supprimerCourbe={() => this.supprimerIndiceCourbe(indCourbe)}
                disabled={this.props.affichageProfil === true}
              />
            </div>
          </>
        );
      }
      let xaxis_type, yaxis_type, yaxis2_type;

      // Factorized axis type configuration
      if (
        parseInt(this.state.graph_type_id) ===
        glossaire_type_de_graphe.graphe_x_t
      ) {
        xaxis_type = 'date';
      } else {
        xaxis_type = 'linear';
      }
      // Y axes are always linear regardless of graph type
      yaxis_type = 'linear';
      yaxis2_type = 'linear';

      this.setState({
        ...this.state,
        listeFormulaireCourbe: listeFormulaireCourbe,
        xaxis_type: xaxis_type,
        yaxis_type: yaxis_type,
        yaxis2_type: yaxis2_type,
      });
    }

    if (
      this.props !== undefined &&
      this.props.preconfigurerGraphe === undefined &&
      !jsDictionaryEquals(prevProps, this.props)
    ) {
      this.setState({
        //todo: paramètre par défaut du graphe
        ...this.state,
      });
    } else if (
      this.props !== undefined &&
      this.props.preconfigurerGraphe !== undefined &&
      !jsDictionaryEquals(
        prevProps.preconfigurerGraphe,
        this.props.preconfigurerGraphe
      )
    ) {
      this.setState({
        //todo: pré-configuration du formulaire
        ...this.state,
        ...this.props.preconfigurerGraphe,
        xaxis: {
          ...this.props.preconfigurerGraphe.xaxis,
        },
        yaxis: {
          ...this.props.preconfigurerGraphe.yaxis,
        },
        yaxis2: {
          ...this.props.preconfigurerGraphe.yaxis2,
        },
      });
    }
  }

  gererEnvoi = () => {
    //mise en forme de l'objet pour l'envoi de la requête API. Les nombres
    //partent tels que saisis : c'est le schéma qui les convertit, et qui
    //distingue ainsi un champ vide (null) d'une saisie illisible (refusée),
    //là où parseInt donnait NaN dans les deux cas.
    let formulaireGraphe = {
      //clé du formulaire de graphe de l'api
      project_id: this.state.project_id,
      private: this.state.private,
      time_refresh: this.state.time_refresh,
      time_period: this.state.time_period,
      measures_num: this.state.measures_num,
      time_zone: this.state.time_zone,
      cumul_interval: this.state.cumul_interval,
      cumul_num: this.state.cumul_num,
      select_time: this.state.select_time,
      time_interval: [this.state.time_interval[0], this.state.time_interval[1]],

      graph_type_id: this.state.graph_type_id,
      graph_name: this.state.graph_name,
      title: this.state.title,
      subtitle: this.state.subtitle,
      showlegend: this.state.showlegend,
      showgrid: this.state.showgrid === null ? 1 : this.state.showgrid,
      xaxis: {
        ...this.state.xaxis,
        type: this.state.xaxis_type,
      },
      yaxis: {
        ...this.state.yaxis,
        type: this.state.yaxis_type,
      },
      yaxis2: {
        ...this.state.yaxis2,
        type: this.state.yaxis2_type,
      },
      curves_conf_list: [...this.state.curves_conf_list],
      list_template_id: [...this.state.list_template_id],
      barmode: this.state.barmode,
    };
    // formulaireGraphe["configs_y2axis_list"] = newConfigs_y2axis_list;

    // //ajout de la configuration de barmode si une courbe au moins à un type === "bar"
    // for(let courbe of this.state.curves_conf_list){
    //     if(courbe.type === "bar"){
    //         formulaireGraphe["barmode"] = this.state.barmode
    //         break;
    //     }
    // }

    //Envoi la requête de création de graphe si le graphe n'a pas de pré-remplissage des champs du formulaire sinon modification
    const enCreation =
      this.props !== undefined && this.props.preconfigurerGraphe === undefined;
    if (!enCreation) {
      formulaireGraphe['graph_id'] = this.props.preconfigurerGraphe.graph_id;
    }

    const { valide, donnees, erreurs } = validerFormulaire(
      enCreation ? schemaNouveauGraphe : schemaModificationGraphe,
      formulaireGraphe
    );
    this.setState({ erreurs });
    if (!valide) {
      return;
    }

    if (enCreation) {
      this.props.reqCreerGraphe(donnees);
    } else {
      this.props.reqModifierGraphe(donnees);
    }
  };

  // Ouvre la section qui contient un champ en faute : son message resterait
  // sinon invisible dans une section repliée. undefined, et non false, pour ne
  // pas refermer une section que l'utilisateur a ouverte.
  ouvrirSiErreur = (champs) =>
    champs.some((champ) => messageDuChamp(this.state.erreurs, champ))
      ? true
      : undefined;

  // Replace multiple similar methods with a single generic one:
  gererEtatGeneric = (name, value) => {
    this.setState({ ...this.state, [name]: value });
  };

  // Then update the specific methods to use this generic one:
  gererProjetId = (projetId) => this.gererEtatGeneric('project_id', projetId);
  gererListTemplateId = (listTemplateId) =>
    this.gererEtatGeneric('list_template_id', [...listTemplateId]);
  gererTimeRefresh = (time_refresh) =>
    this.gererEtatGeneric('time_refresh', parseInt(time_refresh));
  gererTimePeriod = (time_period) =>
    this.gererEtatGeneric('time_period', parseInt(time_period));
  gererTimeZone = (time_zone) => this.gererEtatGeneric('time_zone', time_zone);

  gererEtatDeCibleName = (event) =>
    this.setState({ ...this.state, [event.target.name]: event.target.value });
  gererAxe = (axe, etatAxe) => {
    this.setState({ ...this.state, [axe]: etatAxe });
  };
  ajouterCourbe = () =>
    this.setState((prevState) => ({
      ...this.state,
      curves_conf_list: [...prevState.curves_conf_list, valeurParDefautCourbe],
    }));
  gererCourbe = (indCourbe, newConfigCourbe) => {
    let newCurves_conf_list = [...this.state.curves_conf_list];
    newCurves_conf_list[indCourbe] = newConfigCourbe;
    this.setState({ ...this.state, curves_conf_list: newCurves_conf_list });
  };
  supprimerIndiceCourbe = (indCourbe) => {
    let newCurves_conf_list = [];
    for (let courbe of this.state.curves_conf_list) {
      newCurves_conf_list.push({ ...courbe });
    }
    newCurves_conf_list.splice(indCourbe, 1);
    this.setState({ ...this.state, curves_conf_list: newCurves_conf_list });
  };
  gererConfigSelectUtsDate = (newConfigSelectUtsDate) => {
    this.setState({ ...this.state, select_time: [...newConfigSelectUtsDate] });
  };

  gereDate = (event) => {
    this.setState({ date: event.target.value });

    if (this.state.date !== null) {
      const splitDate = this.state.date.split('-');
      const splitHour = this.state.time.split(':');
      //les mois sont compris entre 0 and 11 (January to December).
      //Les heures sont comprises entre 0 et 23 (00h pour minuit et 23h)
      let datum = new Date(
        Date.UTC(
          splitDate[0],
          parseInt(splitDate[1]) - 1,
          splitDate[2],
          parseInt(splitHour[0]) - 1,
          splitHour[1],
          '00'
        )
      );
      const timeToUnix = datum.getTime();
      this.setState({ select_xaxis_manual_scalingMinX: timeToUnix / 1000 });
    } else {
      // onUpdate(null);
    }
  };
  gererDebut_time_interval = (unix) =>
    this.setState({
      ...this.state,
      time_interval: [unix, this.state.time_interval[1]],
    });
  gererFin_time_interval = (unix) =>
    this.setState({
      ...this.state,
      time_interval: [this.state.time_interval[0], unix],
    });

  // Create a helper function to check for bar type curves
  renderBarModeSelector() {
    // Only render if at least one curve is of type 'bar'
    const hasBarTypeCurve = this.state.curves_conf_list.some(
      (courbe) => courbe.type === 'bar'
    );

    if (!hasBarTypeCurve) {
      return null;
    }

    return (
      <div className={[s.row, styles.info].join(' ')}>
        <div className={s.col_12}>
          <div className={[styles.stil2].join(' ')}>
            {checkMot('mode_d_affichage_de_bar')}
          </div>
          <select
            onChange={(event) => this.gererEtatDeCibleName(event)}
            name="barmode"
            defaultValue={this.state.barmode}
            disabled={this.props.affichageProfil === true}
            value={this.state.barmode}
            className={[s.custom_select, s.mr_sm_2].join(' ')}
          >
            <option value="stack">{checkMot('stack')}</option>
            <option value="group">{checkMot('groupe')}</option>
            <option value="relative">{checkMot('relative')}</option>
          </select>
        </div>
      </div>
    );
  }

  render() {
    return (
      <>
        <div className={styles.ConteneurInfo}>
          <div className={[s.container, s.text_left].join(' ')}>
            <form onSubmit={(event) => event.preventDefault()}>
              <Collapse
                expandText={checkMot('info_general')}
                showAdvanceParameters={this.ouvrirSiErreur([
                  'project_id',
                  'graph_name',
                ])}
              >
                {/**DEBUT project_id **/}
                <div className={s.form_row}>
                  <FormulaireSelectionProjet
                    affichageProfil={this.props.affichageProfil}
                    gererProjetId={this.gererProjetId}
                    preconfigurerProjetId={this.state.project_id}
                  />
                </div>
                <MessageErreur
                  cle={messageDuChamp(this.state.erreurs, 'project_id')}
                />
                {/**FIN project_id **/}
                <div className={s.form_group}>
                  {/**DEBUT graph_name**/}
                  <div className={[s.form_row, s.align_items_center].join(' ')}>
                    <div className={s.col_12}>
                      <label className={[styles.stil2].join(' ')}>
                        {checkMot('nom_du_graphe')}
                      </label>
                      <input
                        type="text"
                        pattern="[0-9a-zA-Z._%+-\\s ]+"
                        className={[
                          s.form_control,
                          s.mb_2,
                          messageDuChamp(this.state.erreurs, 'graph_name')
                            ? classeChampEnErreur
                            : '',
                        ].join(' ')}
                        placeholder="nom_du_graphe"
                        name="graph_name"
                        value={this.state.graph_name}
                        disabled={this.props.affichageProfil === true}
                        onChange={(event) => this.gererEtatDeCibleName(event)}
                      />
                      <MessageErreur
                        cle={messageDuChamp(this.state.erreurs, 'graph_name')}
                      />
                    </div>
                  </div>
                </div>
                {/**FIN graph_name**/}

                <div className={s.form_group}>
                  {/**DEBUT graph_title **/}
                  <div className={s.form_row}>
                    <div className={s.col_6}>
                      <label className={styles.stil2}>
                        {checkMot('titre_du_graphe')}
                      </label>
                      <input
                        type="text"
                        pattern="[0-9a-zA-Z._%+-\\s ]+"
                        className={[s.form_control, s.mb_2].join(' ')}
                        placeholder="titre_du_graphe"
                        name="title"
                        disabled={this.props.affichageProfil === true}
                        value={this.state.title}
                        onChange={(event) => this.gererEtatDeCibleName(event)}
                      />
                    </div>

                    <div className={s.col_6}>
                      <label className={styles.stil2}>
                        {checkMot('sous_titre_du_graphe')}
                      </label>
                      <input
                        type="text"
                        pattern="[0-9a-zA-Z._%+-\\s ]+"
                        className={[s.form_control, s.mb_2].join(' ')}
                        placeholder="sous_titre_du_graphe"
                        name="subtitle"
                        disabled={this.props.affichageProfil === true}
                        value={this.state.subtitle}
                        onChange={(event) => this.gererEtatDeCibleName(event)}
                      />
                    </div>
                  </div>
                </div>
                {/**FIN graph_title **/}
                {/**DEBUT private**/}
                <div className={[s.form_row, styles.heder].join(' ')}>
                  <div className={s.col_12}>
                    <label className={styles.stil2}>
                      {checkMot('acces_prive')}
                    </label>
                    {/* Sans valeur, la liste qui précédait affichait sa
                        première option, « privé » : même lecture ici. */}
                    <Interrupteur
                      name="private"
                      label={checkMot('prive')}
                      valeur={this.state.private ?? 1}
                      disabled={this.props.affichageProfil === true}
                      onChange={(valeur, nom) =>
                        this.gererEtatGeneric(nom, valeur)
                      }
                    />
                  </div>
                </div>
                {/**FIN private**/}

                <div className={[s.form_group, styles.stil2].join(' ')}>
                  {/**DEBUT showlegend and showgrid**/}
                  <div className={s.form_row}>
                    <div className={s.col_6}>
                      {/**DEBUT showgrid**/}
                      <label className={styles.stil2}>
                        {checkMot('grille')}
                      </label>
                      {/* null vaut 1 à l'envoi (gererEnvoi) : on l'affiche
                          donc allumé. */}
                      <Interrupteur
                        name="showgrid"
                        label={checkMot('afficher_la_grille_de_fond')}
                        valeur={this.state.showgrid ?? 1}
                        disabled={this.props.affichageProfil === true}
                        onChange={(valeur, nom) =>
                          this.gererEtatGeneric(nom, valeur)
                        }
                      />
                    </div>
                    {/**FIN showgrid**/}
                    <div className={s.col_6}>
                      {/**DEBUT showlegend**/}
                      <label className={styles.stil2}>
                        {checkMot('legende_du_graphe')}
                      </label>
                      {/* Sans valeur, la liste qui précédait affichait sa
                          première option, « afficher » : même lecture ici. */}
                      <Interrupteur
                        name="showlegend"
                        label={checkMot('afficher_la_legende')}
                        valeur={this.state.showlegend ?? 1}
                        disabled={this.props.affichageProfil === true}
                        onChange={(valeur, nom) =>
                          this.gererEtatGeneric(nom, valeur)
                        }
                      />
                    </div>
                    {/**FIN showlegend**/}
                  </div>
                </div>
                {/**FIN showlegend and showgrid and **/}

                {this.renderBarModeSelector()}

                <div className={[s.form_group, styles.stylebas].join(' ')}>
                  {/**DEBUT graph_type_id**/}
                  <label className={styles.stil2}>
                    {checkMot('type_de_graphe')}
                  </label>
                  <select
                    onChange={(event) => this.gererEtatDeCibleName(event)}
                    name="graph_type_id"
                    defaultValue={this.state.graph_type_id}
                    value={this.state.graph_type_id}
                    disabled={
                      this.props.preconfigurerGraphe !== undefined ||
                      this.props.affichageProfil === true
                    }
                    className={[s.custom_select, s.mr_sm_2].join(' ')}
                  >
                    {Object.keys(glossaire_type_de_graphe)
                      .filter((key) => key !== 'graphe_automatique')
                      .map((keyTypeDeGraphe) => {
                        return (
                          <option
                            value={glossaire_type_de_graphe[keyTypeDeGraphe]}
                          >
                            {checkMot(keyTypeDeGraphe)}
                          </option>
                        );
                      })}
                  </select>
                </div>

                {/**FIN graph_type_id**/}
              </Collapse>
              <Collapse
                expandText={checkMot('info_avance')}
                showAdvanceParameters={this.ouvrirSiErreur([
                  'time_interval',
                  'time_refresh',
                  'time_period',
                  'measures_num',
                  'cumul_num',
                ])}
              >
                <div className={[styles.stil2, styles.stilles].join(' ')}>
                  {/*Formulaire pour l'interval de récupération des données*/}
                  <div className={s.form_group}>
                    {/**DEBUT time_interval**/}
                    <div
                      className={[s.form_row, s.align_items_center].join(' ')}
                    >
                      <label className={[s.col_12, styles.news].join(' ')}>
                        {checkMot(
                          'interval_de_recuperation_de_donnees_debut_fin'
                        )}
                      </label>
                      <div
                        className={[s.col_6, s.card_body, styles.news].join(
                          ' '
                        )}
                      >
                        <FormulaireSelectionDateHeureUnix
                          value={this.state.time_interval[0]}
                          gereUnixDate={this.gererDebut_time_interval}
                          disabled={this.props.affichageProfil === true}
                        />
                      </div>
                      <div
                        className={[s.col_6, s.card_body, styles.news].join(
                          ' '
                        )}
                      >
                        <FormulaireSelectionDateHeureUnix
                          value={this.state.time_interval[1]}
                          gereUnixDate={this.gererFin_time_interval}
                          disabled={this.props.affichageProfil === true}
                        />
                      </div>
                    </div>
                    <MessageErreur
                      cle={messageDuChamp(this.state.erreurs, 'time_interval')}
                    />
                  </div>
                  {/**FIN time_interval**/}

                  <div className={[styles.sti1].join(' ')}>
                    <div className={s.form_group}>
                      {/**DEBUT time_refresh**/}
                      <div className={s.row}>
                        <div className={s.col_12}>
                          <label className={styles.stil2}>
                            {checkMot('temps_apres_actualisation')}
                          </label>
                          <FormulaireSaisieDuree
                            affichageProfil={this.props.affichageProfil}
                            gererDuree={this.gererTimeRefresh}
                            preconfigurerDuree={this.state.time_refresh}
                          />
                          <MessageErreur
                            cle={messageDuChamp(
                              this.state.erreurs,
                              'time_refresh'
                            )}
                          />
                        </div>
                      </div>
                    </div>
                    {/**FIN time_refresh**/}
                    <div className={s.form_group}>
                      {/**DEBUT time_period**/}
                      <div className={s.form_row}>
                        <div className={s.col_12}>
                          <label className={styles.stil2}>
                            {checkMot(
                              'recuperation_des_donnees_sur_le_dernier_interval_de_temps_jusqu_a_present'
                            )}
                            <HoverButton
                              customClass={styles.btn_stile}
                              imageUrl={help}
                            />
                          </label>
                          <FormulaireSaisieDuree
                            affichageProfil={this.props.affichageProfil}
                            gererDuree={this.gererTimePeriod}
                            preconfigurerDuree={this.state.time_period}
                          />
                          <MessageErreur
                            cle={messageDuChamp(
                              this.state.erreurs,
                              'time_period'
                            )}
                          />
                        </div>
                      </div>
                    </div>
                    {/**FIN time_period**/}
                    <div className={s.form_group}>
                      {/**DEBUT measures_num**/}
                      <div className={s.form_row}>
                        <div className={s.col_12}>
                          <label className={styles.stil2}>
                            {checkMot(
                              'recuperation_des_n_derniere_donnees_jusqu_a_present'
                            )}
                            <HoverButton
                              customClass={styles.btn_stile}
                              imageUrl={helpB}
                            />
                          </label>
                          <input
                            type="text"
                            pattern="[0-9]+"
                            className={[
                              s.form_control,
                              s.mb_2,
                              messageDuChamp(this.state.erreurs, 'measures_num')
                                ? classeChampEnErreur
                                : '',
                            ].join(' ')}
                            placeholder="measures_num"
                            name="measures_num"
                            value={this.state.measures_num}
                            disabled={this.props.affichageProfil === true}
                            required
                            onChange={(event) =>
                              this.gererEtatDeCibleName(event)
                            }
                          />
                          <MessageErreur
                            cle={messageDuChamp(
                              this.state.erreurs,
                              'measures_num'
                            )}
                          />
                        </div>
                      </div>
                    </div>
                    {/**FIN measures_num**/}
                    {/**DEBUT time_zone**/}
                    <div className={s.form_group}>
                      {/**DEBUT measures_num**/}
                      <div className={s.form_row}>
                        <div className={s.col_12}>
                          <FormulaireSelectionTimeZone
                            affichageProfil={this.props.affichageProfil}
                            gererTimeZone={this.gererTimeZone}
                            preconfigurerTimeZone={this.state.time_zone}
                          />
                        </div>
                      </div>
                    </div>
                    {/**FIN time_zone**/}
                    <div className={s.form_group}>
                      {/**DEBUT cumul_interval && cumul_num**/}
                      <div className={s.form_row}>
                        <div className={s.col_5}>
                          <label className={styles.stil2}>
                            {checkMot('cumul_interval')}
                            <HoverButton
                              customClass={styles.btn_stile}
                              texte={checkMot(
                                'Ce champ spécifie l\'intervalle de temps pour le cumul des données. Les valeurs possibles sont : "heure", "jour", "semaine", "mois", "année". La valeur par défaut est une chaîne vide ("").'
                              )}
                            />
                          </label>
                          <select
                            onChange={(event) =>
                              this.gererEtatDeCibleName(event)
                            }
                            name="cumul_interval"
                            defaultValue={this.state.cumul_interval}
                            disabled={this.props.affichageProfil === true}
                            value={this.state.cumul_interval}
                            className={[s.custom_select, s.mr_sm_2].join(' ')}
                          >
                            <option value="">{checkMot('selectionne')}</option>
                            <option value="heure">{checkMot('heure')}</option>
                            <option value="jour">{checkMot('jour')}</option>
                            <option value="semaine">
                              {checkMot('semaine')}
                            </option>
                            <option value="mois">{checkMot('mois')}</option>
                            <option value="annee">{checkMot('annee')}</option>
                          </select>
                        </div>
                        <div className={s.col_7}>
                          <label className={styles.stil2}>
                            {checkMot('nombre_de_periodes_de_cumul')}
                            <HoverButton
                              customClass={styles.btn_stile}
                              texte={checkMot(
                                'Ce champ indique le nombre de périodes pour lesquelles les données seront cumulées. Si la valeur est positive, elle représente le nombre de périodes passées à inclure dans le cumul (par exemple, 2 pour les deux dernières semaines si "cumul_interval" est défini sur \'semaine\'). Si la valeur est négative, elle représente le nombre de périodes futures à inclure dans le cumul. La valeur par défaut est nulle.'
                              )}
                            />
                          </label>
                          <input
                            type="text"
                            pattern="[0-9]+"
                            className={[
                              s.form_control,
                              s.mb_2,
                              messageDuChamp(this.state.erreurs, 'cumul_num')
                                ? classeChampEnErreur
                                : '',
                            ].join(' ')}
                            placeholder="cumul_num"
                            name="cumul_num"
                            value={this.state.cumul_num}
                            disabled={this.props.affichageProfil === true}
                            required
                            onChange={(event) =>
                              this.gererEtatDeCibleName(event)
                            }
                          />
                          <MessageErreur
                            cle={messageDuChamp(this.state.erreurs, 'cumul_num')}
                          />
                        </div>
                      </div>
                    </div>
                    {/**FIN cumul_interval && cumul_num**/}
                    <div className={s.form_group}>
                      {/**DEBUT select_time**/}
                      <div className={s.form_row}>
                        <div className={s.col_12}>
                          <label className={styles.stil2}>
                            {checkMot(
                              'recuperation_des_donnees_des_dates_selectionnees'
                            )}
                          </label>
                          <FormulaireSelectUtsDate
                            preConfigSelectUtsDate={this.state.select_time}
                            gererConfigSelectUtsDate={
                              this.gererConfigSelectUtsDate
                            }
                            disabled={this.props.affichageProfil === true}
                          />
                        </div>
                      </div>
                    </div>
                    {/**FIN select_time**/}
                  </div>

                  {/*Formulaire de configuration du graphe en général*/}
                </div>
              </Collapse>
              <Collapse expandText={checkMot('parametre_de_axe')}>
                <AxisFormField
                  axisKey={'xaxis'}
                  axisName={checkMot('xaxis')}
                  axisConfig={this.state.xaxis}
                  axisType={this.state.xaxis_type}
                  gererConfigAxe={this.gererAxe}
                  gererEtatDeCibleName={this.gererEtatDeCibleName}
                  disabled={this.props.affichageProfil === true}
                />
                <AxisFormField
                  axisKey={'yaxis'}
                  axisName={checkMot('yaxis')}
                  axisConfig={this.state.yaxis}
                  axisType={this.state.yaxis_type}
                  gererConfigAxe={this.gererAxe}
                  gererEtatDeCibleName={this.gererEtatDeCibleName}
                  disabled={this.props.affichageProfil === true}
                />
                <AxisFormField
                  axisKey={'yaxis2'}
                  axisName={checkMot('yaxis2')}
                  axisConfig={this.state.yaxis2}
                  axisType={this.state.yaxis2_type}
                  gererConfigAxe={this.gererAxe}
                  gererEtatDeCibleName={this.gererEtatDeCibleName}
                  disabled={this.props.affichageProfil === true}
                />
              </Collapse>
              {parseInt(this.state.graph_type_id) ===
                glossaire_type_de_graphe.graphe_x_y_t ||
              parseInt(this.state.graph_type_id) ===
                glossaire_type_de_graphe.graphe_x_y ? (
                <Collapse expandText={checkMot('parametre_gabarit')}>
                  <FormulaireSelectionGabarits
                    preconfigurerListTemplateId={this.state.list_template_id}
                    gererListTemplateId={this.gererListTemplateId}
                    desactiverModification={this.props.affichageProfil === true}
                  />
                </Collapse>
              ) : null}
              <Collapse expandText={checkMot('parametre_courbe')}>
                {/*liste de formulaireCourbe*/}
                {/*bouton pour ajouter une courbe*/}
                {this.state.listeFormulaireCourbe}
                {this.props.affichageProfil === true ? null : (
                  <>
                    <Bouton
                      type={type_btn.succes}
                      ajoutClass={styles.addCurve}
                      cliquer={(e) => {
                        e.preventDefault();
                        this.ajouterCourbe();
                      }}
                    >
                      <AiFillPlusCircle size={16} /> courbe
                    </Bouton>
                    <br />
                  </>
                )}
              </Collapse>
              {this.props.affichageProfil === true ? undefined : (
                <div className={s.form_group}>
                  <div
                    className={[s.d_flex, s.justify_content_between].join(' ')}
                  >
                    <div>
                      <Bouton
                        cliquer={(e) => {
                          e.preventDefault();
                          this.props.annuler();
                        }}
                        type={type_btn.danger}
                      >
                        {checkMot('annuler')}
                      </Bouton>
                    </div>
                    <div>
                      {this.props !== undefined &&
                      this.props.preconfigurerGraphe === undefined ? (
                        <AttenteRequete
                          request_type={requestType.creer_un_graphe}
                          str={checkMot('creation_en_cour')}
                        >
                          <Bouton
                            ajoutClass={styles.Bts}
                            type={type_btn.succes}
                            cliquer={() => this.gererEnvoi()}
                          >
                            <AiOutlineCheck /> {checkMot('creer')}
                          </Bouton>
                        </AttenteRequete>
                      ) : (
                        <AttenteRequete
                          request_type={requestType.modifier_un_graphe}
                          str={checkMot('modification_en_cour')}
                        >
                          <Bouton
                            cliquer={() => this.gererEnvoi()}
                            type={type_btn.succes}
                          >
                            {checkMot('enregistrer')}
                          </Bouton>
                        </AttenteRequete>
                      )}
                    </div>
                  </div>
                </div>
              )}
            </form>
          </div>
        </div>
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    reqCreerGraphe: (formulaireGrapheT_X) =>
      dispatch(actions.reqCreerGraphe(formulaireGrapheT_X)),
    reqModifierGraphe: (formulaireGrapheT_X) =>
      dispatch(actions.reqModifierGraphe(formulaireGrapheT_X)),
  };
};

export default connect(null, mapDispatchToProps)(FormulaireGraphe);
